import 'Layouts/default'
import './catalog/catalog'

if (document.querySelector('.js-countdown')) {
    import('Functions/countdown').then(({ initCountdowns }) => {
        initCountdowns();
    });
}